import "./AboutTab.css";
import { useState } from "react";
import { Link } from "react-router-dom";
import { ABOUT } from "../../data/about";
import { SONGS } from "../../data/songs";
import { track } from "../../utils/analytics";
import nightPhoto from "../../assets/portraits/about-night.jpg";
import dayPhoto from "../../assets/portraits/about.jpg";

export const LANGUAGES = [
  { key: "vi", label: "VI" },
  { key: "en", label: "EN" },
];

/*
 * Round photo that flips like a card: the night photo first, the everyday
 * one on the back. With a mouse it flips while hovered (a click flips it
 * again); on touch screens a tap flips it. The custom cursor hides over it.
 */
function FlipAvatar() {
  const [flipped, setFlipped] = useState(false);
  const flip = (next) => {
    setFlipped(next);
    if (next) track("photo_flip");
  };
  const onHover = (show) => (event) => {
    if (event.pointerType === "mouse") flip(show);
  };

  return (
    <button
      type="button"
      className={`about-avatar ${flipped ? "is-flipped" : ""}`}
      onPointerEnter={onHover(true)}
      onPointerLeave={onHover(false)}
      onClick={() => flip(!flipped)}
      aria-pressed={flipped}
      aria-label="Flip photo"
      data-cursor-hide
    >
      <span className="about-avatar-card">
        <img className="about-avatar-face" src={nightPhoto} alt="" width="240" height="240" />
        <img
          className="about-avatar-face about-avatar-back"
          src={dayPhoto}
          alt=""
          width="240"
          height="240"
        />
      </span>
    </button>
  );
}

// A journey line; {song} becomes the song's title, linking to its page
function JourneyText({ text, song }) {
  const release = song ? SONGS[song] : null;
  if (!release || !text.includes("{song}")) return text;
  const [before, after] = text.split("{song}");
  return (
    <>
      {before}
      <Link className="about-song" to={`/${song}`}>
        {release.title}
      </Link>
      {after}
    </>
  );
}

/*
 * The About tab of the info panel (InfoPanel.js): bio and journey, from data/about.js in the chosen language (the VI / EN switch sits
 * in the panel's tab row).
 */
function AboutTab({ language }) {
  const text = ABOUT[language];

  return (
    <div className="about" lang={language}>
      {/* Title on the left, the round flip photo at the right end of its line */}
      <div className="about-head">
        <h2 className="about-title">thangcao</h2>
        <FlipAvatar />
      </div>
      {text.bio.map((paragraph) => (
        <p key={paragraph} className="about-bio">
          {paragraph}
        </p>
      ))}
      <p className="about-genres">{text.genres}</p>

      <h3 className="contact-label about-journey-label">{text.journeyLabel}</h3>
      <ol className="about-journey">
        {text.journey.map(({ when, what, song }) => (
          <li key={when}>
            <span className="about-when">{when}</span>
            <span className="about-what">
              <JourneyText text={what} song={song} />
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
}

export default AboutTab;
